import React from "react";
import { useTranslate } from 'react-redux-multilingual';
import { OverlayTrigger, Tooltip } from "react-bootstrap";

// Style import
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

const  DownloadCardActionButton = (props) => {
    const t = useTranslate();

    return (
        <OverlayTrigger
            placement="bottom"
            overlay={
                <Tooltip id={`tooltip-${props.index}`}>
                    {t('download')}
                </Tooltip>
            }
        >
            <a style={{cursor:'Pointer', color:'#FF8919'}} href={'/session/abonnement_card/download/'+props.id+'/'+props.token} target='_blank' ><FontAwesomeIcon icon={faDownload} /></a>
        </OverlayTrigger>  
    )
}

export default DownloadCardActionButton;